module.exports = __webpack_public_path__ + "static/img/step-2.2deb081a.png";